module.exports = __webpack_public_path__ + "static/media/ice.ebed4c7f.svg";